import { render, staticRenderFns } from "./productsFollowSale.vue?vue&type=template&id=5b53cd07&scoped=true"
import script from "./productsFollowSale.vue?vue&type=script&lang=js"
export * from "./productsFollowSale.vue?vue&type=script&lang=js"
import style0 from "./productsFollowSale.vue?vue&type=style&index=0&id=5b53cd07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b53cd07",
  null
  
)

export default component.exports